(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("reader", [], factory);
	else if(typeof exports === 'object')
		exports["reader"] = factory();
	else
		root["reader"] = factory();
})(self, () => {
return 